export default __webpack_public_path__ + "static/media/4.e68af539.png";